/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type FeedbackForm_form$ref = any;
type FeedbackForm_responses$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type FeedbackItem_toReview$ref: FragmentReference;
declare export opaque type FeedbackItem_toReview$fragmentType: FeedbackItem_toReview$ref;
export type FeedbackItem_toReview = {|
  +id: string,
  +reviewee: ?{|
    +firstName: string,
    +lastName: string,
  |},
  +form: ?{|
    +id: string,
    +title: string,
    +$fragmentRefs: FeedbackForm_form$ref,
  |},
  +responses: ?{|
    +$fragmentRefs: FeedbackForm_responses$ref
  |},
  +$refType: FeedbackItem_toReview$ref,
|};
export type FeedbackItem_toReview$data = FeedbackItem_toReview;
export type FeedbackItem_toReview$key = {
  +$data?: FeedbackItem_toReview$data,
  +$fragmentRefs: FeedbackItem_toReview$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FeedbackItem_toReview",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ExternalUserNode",
      "kind": "LinkedField",
      "name": "reviewee",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ReviewFormNode",
      "kind": "LinkedField",
      "name": "form",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FeedbackForm_form"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ReviewFormResponseNodeConnection",
      "kind": "LinkedField",
      "name": "responses",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FeedbackForm_responses"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ExternalReviewerNominationNode"
};
})();
// prettier-ignore
(node/*: any*/).hash = '5213b325192fac01281ce2bdd809ae22';

module.exports = node;
